module.exports = __webpack_public_path__ + "static/media/ford.5ba08da8.png";